import { useMemo } from 'react';
import { Configuration, ProductListsApi } from '@/api';
import { productListQueryKeys } from '@/api/queries/productListQueryKeys';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';

const useGetEffectivePortfolioQuery = (storeId?: string, supplierId?: string, enabled = true) => {
  const auth = useAuth();
  const productListsApi = useMemo(() => new ProductListsApi(new Configuration(auth)), [auth]);

  const query = useQuery({
    queryKey: productListQueryKeys.portfolio(storeId, supplierId),
    queryFn: () => {
      if (!storeId) throw new Error('Missing storeId');
      return productListsApi.getEffectivePortfolio(storeId, supplierId);
    },
    enabled: enabled && Boolean(storeId),
  });

  return {
    portfolio: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
};

export default useGetEffectivePortfolioQuery;
